import { motion } from 'motion/react';

interface RiskRecalculationBannerProps {
  onRecalculate: () => void;
}

export function RiskRecalculationBanner({ onRecalculate }: RiskRecalculationBannerProps) {
  return (
    <div className="dashboard-reset w-full h-fit-content bg-[#f0f5f6] border border-[#183344] border-solid rounded-[10px] p-[24px] flex flex-col gap-[20px]">
      {/* Body */}
      <div className="flex flex-col gap-[24px] w-full">
        {/* Content */}
        <div className="flex flex-col gap-[16px] w-full">
          {/* Title & Description */}
          <div className="flex flex-col gap-[16px] w-full">
            {/* Main Title */}
            <div className="flex flex-col gap-[8px] w-full">
              <p className="font-bold text-[20px] leading-[1.3] text-[#0e1d27] w-full">
                Updates have been made to your health data
              </p>
            </div>
          </div>
          <p className="font-normal text-[16px] leading-[24px] tracking-[0.2px] text-[#0e1d27] w-full">
            Please save your changes to see your updated risk model.
          </p>
        </div>
      </div>

      {/* Button */}
      <motion.button
        onClick={onRecalculate}
        className="w-full bg-[#7cf1c7] rounded-[9999px] px-[16px] py-[8px] flex items-center justify-center gap-[8px]"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        transition={{ duration: 0.2 }}
        type="button"
        aria-label="Recalculate Risk Score"
      >
        <span className="font-semibold text-[16px] leading-[24px] text-[#183344] whitespace-nowrap">
          Recalculate Risk Score
        </span>
      </motion.button>
    </div>
  );
}
